import { gql } from '@apollo/client';

export const orderHomeQueryApollo = gql`
  mutation OrderHomeContentPackage(
    $comparisonId: UUID!
    $chosenProductKrn: String!
    $frontEndName: String
    $package: HomeContentPackageSchema_PackageInput!
    $sessionId: String!
    $clientId: String!
    $googleAnalyticsId: String
    $googleAnalyticsSessionId: String
    $gclid: String
    $fbp: String
    $fbc: String
    $vwoId: String
  ) {
    orderHomeContentPackage(
      comparisonId: $comparisonId
      chosenProductKrn: $chosenProductKrn
      frontEndName: $frontEndName
      input: {
        masterAgreementPackages: [$package]
        commonTechnical: {
          sessionId: $sessionId
          senderId: $clientId
          googleAnalyticsId: $googleAnalyticsId
          googleAnalyticsSessionId: $googleAnalyticsSessionId
          gclid: $gclid
          fbp: $fbp
          fbc: $fbc
          vwoId: $vwoId
        }
      }
    ) {
      orderId
      errors
    }
  }
`;
